var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import api from '@/shared/api';
import config from '@/config';
import { getRelationNameMapper } from '@/shared/components/RelationName';
import { useIntl } from 'react-intl';
import RelationSearch from '@/shared/components/input/RelationSearch';
import EditableToggle from './EditableToggle';
var EditableRelationSearch = function (_a) {
    var onChange = _a.onChange, value = _a.value, crmTypes = _a.crmTypes, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b;
    var intl = useIntl();
    var _c = useState(''), displayName = _c[0], setDisplayName = _c[1];
    useEffect(function () {
        if (!value) {
            setDisplayName('');
            return;
        }
        var nameMapper = getRelationNameMapper(intl);
        api.base
            .post("".concat(config.appUrls.api, "/api/relation/names"), [value])
            .then(function (_a) {
            var data = _a.data;
            if (data === null || data === void 0 ? void 0 : data[0]) {
                setDisplayName(nameMapper(data[0]));
            }
        })
            .catch(function () { });
    }, [value, intl]);
    var initialItem = value ? { key: value, label: displayName || undefined } : null;
    return (_jsx(EditableToggle, __assign({ onSubmit: function (selected) { var _a, _b; return onChange((_b = (_a = selected === null || selected === void 0 ? void 0 : selected.id) !== null && _a !== void 0 ? _a : selected === null || selected === void 0 ? void 0 : selected.key) !== null && _b !== void 0 ? _b : null); }, value: value, readOnly: readOnly, displayValue: displayName ? (_jsx("span", { children: displayName })) : (_jsx("i", { className: "glyphicon glyphicon-pencil" })) }, { children: function (_a) {
            var setInputValue = _a.setInputValue, submit = _a.submit;
            return (_jsx(OutsideClickHandler, __assign({ onOutsideClick: submit }, { children: _jsx(RelationSearch, { initialSelectedItem: initialItem, onChange: function (relation) {
                        setInputValue(relation).then(submit);
                    }, crmTypes: crmTypes, small: true }) })));
        } })));
};
export default EditableRelationSearch;
